<div mat-dialog-title><h4 class="fs-20"><strong>{{confirmData?.title}}</strong></h4></div>
<mat-dialog-content aria-label="Dialog Content">
  <div>
    <div class="modal-body">
      <div>
        <span class="fs-17 mb-2" [innerHTML]="confirmData?.message"></span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" aria-label="Dialog Actions" class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  <button [id]="ids?.cancel" class='btn btn-primary-outline order-2 order-md-1'
    (click)="target(false)">{{confirmData?.cancelText }}</button>
  <button [id]="ids?.confirm" class="btn btn-primary order-1 order-sm-2" (click)="target(true)">{{
    confirmData?.confirmText }}</button>
</mat-dialog-actions>